<template>
    <div>
        <div>
            <el-form :model="form"   :inline="true"  style="text-align:left;">
                <el-form-item label="综合查询:">
                    <el-input v-model="form.name" placeholder="请输入承销商/机构/延保产品名称" :clearable="true" class="form-name-input"></el-input>
                </el-form-item> 
                <el-form-item label="状态:">
                    <My-Select v-model="form.state" :objSelect="form.state" :options="options" :placeholder="placeholder" @changeSelct="changeSelct"></My-Select>
                </el-form-item> 
                <el-form-item >
                    <el-button type="primary" plain @click="query()">查询</el-button>  
                    <el-button type="primary" plain @click="underwriterProductEditor('add')">新建</el-button>                         
                </el-form-item>           
            </el-form>
        </div>
        <div>
            <My-table :configurationData="configurationData" :operation="operation" :getTableParam="getTableParam" ref="myTable">           
                <template #operation="scope">        
                    <el-button size="mini" type="primary" @click="underwriterProductEditor('update',scope.row)">修改</el-button>
                </template>
            </My-table> 
        </div>


        <el-dialog :title="title"  :visible.sync="underwriterProductEditorDialog" :close-on-click-modal=false width="1200px" >
            <el-form :model="editorForm"  :inline="true" ref="editorForm" :rules="rules" label-width="138px" style="text-align:left">
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="承销商名称:" prop="agentCode">
                            <My-Select v-model="editorForm.agentCode" :objSelect="editorForm.agentCode" :optionBind="optionBindAgent" :options="agentList" 
                            :placeholder="agentPlaceholder"  @changeSelct="changeAgent" :disabled="disabled"></My-Select>                 
                        </el-form-item> 
                    </el-col>
                    <el-col :span="16">
                        <el-form-item label="延保产品名称及ID:" prop="prodCode">
                            <el-input v-model="editorForm.prodCode"  class="prodCode-input input-with-select" :disabled="true">
                                <My-Select slot="prepend" v-model="editorForm.prodCode" :objSelect="editorForm.prodCode" :optionBind="optionBindProd" :options="prodList" 
                                :placeholder="prodPlaceholder"  @changeSelct="changeProd" class="prodCode-select" :disabled="disabled"></My-Select> 
                            </el-input>               
                        </el-form-item>  
                    </el-col>                    
                </el-row>
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="一级销售员提成%:" >
                            <el-input type="number" v-model="editorForm.fistLevelCommission" placeholder="请输入一级销售员提成"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="二级销售员提成%:" >
                            <el-input type="number" v-model="editorForm.secondLevelCommission" placeholder="请输入二级销售员提成" class="commission-input"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="三级销售员提成%:" prop="tertiaryLevelCommission" v-show=sellTypeTag>
                            <el-input type="number" v-model="editorForm.tertiaryLevelCommission" placeholder="请输入三级销售员提成" class="tertiaryLevelCommission-input"></el-input>
                        </el-form-item>
                        <el-form-item label="三级销售员提成%:"  v-show=!sellTypeTag>
                            <el-input type="number" v-model="editorForm.tertiaryLevelCommission" placeholder="请输入三级销售员提成" class="tertiaryLevelCommission-input"></el-input>
                        </el-form-item>
                    </el-col>
                    
                </el-row>
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="承销商提成%:" prop="agentCommission">
                            <el-input type="number" v-model="editorForm.agentCommission" placeholder="请输入承销商提成"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">                        
                        <el-form-item label="友穗提成%:" prop="ysCommission">
                            <el-input type="number" v-model="editorForm.ysCommission" placeholder="请输入友穗提成" class="commission-input"></el-input>
                        </el-form-item>  
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="状态:" prop="state">
                            <el-switch v-model="editorForm.state"></el-switch>
                        </el-form-item> 
                    </el-col>
                </el-row>
            </el-form>
            <el-row style="text-align:right;margin-right: 45px">
                <el-col >
                    <el-button type="success" plain size="mini" @click="addRow()">新增</el-button>
                </el-col>               
            </el-row>
            <el-row style="margin-top:5px;margin-right: 45px">
                <el-table :data="editorForm.agentProducePricesModifyDtoList" border style="width: 100%;">               
                    <el-table-column label="购机价格/房屋面积" >
                        <template slot-scope="scope">
                            <p v-show=!scope.row.isShow> {{ scope.row.priceArea }}~{{ scope.row.priceAreaEnd }}</p>
                            <el-input placeholder="please input min" v-model="scope.row.priceArea" v-show="scope.row.isShow" size="medium" class="priceArea-input" ></el-input>                                   
                            <el-input placeholder="please input max" v-model="scope.row.priceAreaEnd" v-show="scope.row.isShow" size="medium" class="priceArea-input"></el-input>
                        </template>
                    </el-table-column>                
                    <el-table-column label="销售价格" >
                        <template slot-scope="scope">
                            <p v-show=!scope.row.isShow> {{ scope.row.sellingPrice }}</p>
                            <el-input placeholder="please input" v-model="scope.row.sellingPrice" v-show="scope.row.isShow" size="medium"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button size="mini" @click="tableEdit(scope.$index, scope.row)"  v-show=!scope.row.isShow>编辑</el-button>
                            <el-button size="mini" @click="tableEnter(scope.$index, scope.row)"  v-show=scope.row.isShow>确定</el-button>
                            <el-button size="mini" type="danger" @click="tableDel(scope.$index, scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageNum"
                    :page-sizes="[5, 10, 20, 30, 40]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next,jumper"
                    :total="totalNum">
                </el-pagination>                
            </el-row>
            <div slot="footer" style="text-align:center">
                    <el-button type="primary" @click="submitForm('editorForm')">确定</el-button>
                    <el-button @click="resetForm('editorForm')">取消</el-button>
            </div>
            
        </el-dialog>
          
    </div>
</template>

<script>
import common from '../../../public/static/common';
import  asyncApi   from '../../api/asyncApi';
import  arithmetic   from '../../api/arithmetic';

export default { 
    name: 'underwriterProductManagement',
    data(){
        return{
            sellTypeTag:false,
            disabled:false,
            operationType:'', 
            typeTag:0,  
            title:'',         
            optionBindAgent:{
                label:"agentName",
                value:"agentCode"
            },
            optionBindProd:{
                label:"prodName",
                value:"prodCode"
            },
            agentPlaceholder:'请选择承销商名称',
            prodPlaceholder:'请选择延保产品名称',
            agentList:[],
            prodList:[],
            pageNum: 1, // 当前页，默认1
            pageSize: 10, // 每页行数，默认10         
            totalNum: 0, // 总数
            isShow:false,
            productList:[],
            placeholder:'请选择查询状态',
            form:{
                name:'',
                state:''
            },
             // 列表配置
            configurationData:[
                {
                    title: '承销商名称',
                    propertys: 'agentName',
                    width: ''
                },
                {
                    title: '延保产品ID',
                    propertys: 'prodCode',
                    width: ''
                },{
                    title: '延保产品名称',
                    propertys: 'prodName',
                    width: ''
                },
                {
                    title: '一级销售员提成%',
                    propertys: 'fistLevelCommission',
                    width: ''
                },
                {
                    title: '二级销售员提成%',
                    propertys: 'secondLevelCommission',
                    width: ''
                },
                {
                    title: '三级销售员提成%',
                    propertys: 'tertiaryLevelCommission',
                    width: ''
                },
                {
                    title: '承销商提成%',
                    propertys: 'agentCommission',
                    width: ''
                },
                {
                    title: '友穗提成%',
                    propertys: 'ysCommission',
                    width: ''
                },
                {
                    title: '状态',
                    propertys: 'state',
                    width: '',
                    format:common.formatState
                }
            ],
             // 是否有操作按钮 宽度
            operation: {
                show: true,
                width: ''
            },
            getTableParam:{
                url:'/extwarapi/api/agentProduce/page',
                param:''
            },
            underwriterProductEditorDialog:false,
            options:[
                {"key":'',"value":'全部'},
                {"key":'N',"value":'停用中'},
                {"key":'Y',"value":'使用中'},
            ],
            editorForm:{
                id:'',
                agentCode:'',
                agentName:'',
                prodCode:'',
                prodName:'',
                fistLevelCommission:'',
                secondLevelCommission:'',
                tertiaryLevelCommission:'',
                agentCommission:'',
                ysCommission:'',
                state:true,
                agentProducePricesModifyDtoList:[{
                    id:'',
                    priceArea:'',
                    priceAreaEnd:'',
                    sellingPrice:'',
                    createUser:'',
                    modifyUser:''
                }],
                createUser:'',
                modifyUser:''
            },
            rules: {
                agentCode: [
                    { required: true, message: '请选择承销商名称', trigger: 'blur' }
                ],
                prodCode: [
                    { required: true, message: '请选择延保产品名称', trigger: 'blur' }
                ],
                agentCommission: [
                    { required: true, message: '请输入承销商提成', trigger: 'blur' }
                ],
                ysCommission: [
                    { required: true, message: '请输入友穗提成', trigger: 'blur' }
                ],
                tertiaryLevelCommission:[
                    { required: true, message: '请输入三级销售员提成', trigger: 'blur' }
                ],
                state: [
                    { required: true, message: '请选择状态', trigger: 'blur' }
                ]
            }
        }
    },
    methods:{
        underwriterProductEditor(operationType,row){
             this.operationType=operationType;
            if(operationType=='update'){
                this.pageNum=1;   
                this.typeTag=1; 
                this.disabled=true;            
                this.title='承销商销售延保产品修改';
                this.productList=[];
                this.getDetail(row);
            }else{
                //添加 
                this.typeTag=0; 
                this.disabled=false; 
                this.title='承销商销售延保产品新增';            
                this.editorForm.agentProducePricesModifyDtoList=[];
                this.editorForm=common.emptyModel(this.editorForm,["state"]);
            }
            this.underwriterProductEditorDialog=true;
        },
        query(){
            this.getTableParam.param=this.form;
            this.$refs["myTable"].query(1);
        },
        changeSelct(value){
            this.form.state=value;
        },
        addRow(){
            var row={
                id:'',
                priceArea:'',
                priceAreaEnd:'',
                sellingPrice:'',
                createUser:'',
                modifyUser:'',
                state:'',
                isShow:true
            }
            this.productList.push(row);
            this.totalNum++;
            this.pageNum=this.totalNum%this.pageSize==0?(this.totalNum/this.pageSize):(Math.floor(this.totalNum/this.pageSize)+1)
            this.getPageList();           
        },
        tableEdit(index,row){   
          row.isShow = true;
          this.$set(this.editorForm.agentProducePricesModifyDtoList,index, row);
        },
        tableEnter(index,row){          
            row.isShow = false;
            this.$set(this.editorForm.agentProducePricesModifyDtoList,index, row);
            if(row.priceArea==='' || row.priceArea<0){
                this.$alert('购机价格/房屋面积最小值为必填项', '提示信息', {
                    confirmButtonText: '确定',
                    callback: action => {
                        row.isShow = true;
                    }
                });
                return;
            }                
            if(row.priceAreaEnd==='' || row.priceAreaEnd<0){
                this.$alert('购机价格/房屋面积最大值为必填项', '提示信息', {
                    confirmButtonText: '确定',
                    callback: action => {
                        row.isShow = true;
                    }
                });
                return;
            }                

            if(this.operationType=='add'){
                this.$set(this.editorForm.agentProducePricesModifyDtoList,index, row);
            }
            //修改的时候编辑表格调用接口
            if(this.operationType=='update'){
                this.updateProducePrices(index,row);
            }
        },
        tableDel(index,row){         
            //修改的时候删除表格数据调用接口
            if(row.id){
                row.state='D';
                this.updateProducePrices(index, row);
            }else{
                this.productList.splice(index, 1);
                this.editorForm.agentProducePricesModifyDtoList.splice(index, 1);
                this.totalNum--;
            }            
        },
        updateProducePrices(index,row){
            let url="";
            if(row.id){
                url="/extwarapi/api/agentProduce/updateProducePrices";
            }else{
                url="/extwarapi/api/agentProduce/addProducePrices";
            }
            
            let usercode=common.getCurrUser().userCode;
            let param={
                id:row.id,
                priceArea:row.priceArea,
                priceAreaEnd:row.priceAreaEnd,
                agentCode:this.editorForm.agentCode,
                prodCode:this.editorForm.prodCode,
                sellingPrice:row.sellingPrice,
                state:row.state,
                createUser:usercode,
                modifyUser:usercode
            }
            this.axios.post(url, param).then((resp) => {  
                    if(resp.data.code=='0000'){                       
                        if(row.state=='D'){
                            this.productList.splice(index, 1);
                            this.editorForm.agentProducePricesModifyDtoList.splice(index, 1);
                            this.totalNum--;
                        }else{
                            this.$set(this.underwriterForm.agentBranchModifyDtoList,index, row);
                        }
                    }               
                }).catch((resp) => {
                    //console.log('error', resp); 
                })
        },
        handleSizeChange(val) {  
            this.pageSize = val;  
            this.getPageList();      
        },
        handleCurrentChange(val) { 
            this.pageNum = val;
            this.getPageList(); 
        },
        getPageList(){            
            let startRow = (this.pageNum - 1) * this.pageSize+1-1;//开始显示的行  
            let endRow = this.pageNum * this.pageSize;//结束显示的行
            endRow = (endRow > this.totalNum)? this.totalNum : endRow;
            this.editorForm.agentProducePricesModifyDtoList=this.productList.slice(startRow,endRow);  
        },
        //获取承销商数据字典
        async getAgentList(){
            let url ="/extwarapi/api/agent/getAgentEnum";
            let data = await asyncApi.post(url,null);  
            if(data.code=='0000'){
                this.agentList=data.result;
            }
        },
        //获取延保产品名称字典
        async getProdList(code){
            let url ="/extwarapi/api/extension/getProdEnum";
            let data = await asyncApi.post(url,{code:code});  
            if(data.code=='0000'){
                this.prodList=data.result;
                let name=common.getVbyK(this.prodList,this.editorForm.prodCode,"prodCode","prodName");
                this.editorForm.prodName=name;
            }
        },
        //获取延保产品code获取表格数据
        getProdCodeList(code){
            let url="/extwarapi/api/extension/getDetailByProdCode";
            this.axios.post(url, {code:code}).then((resp) => {  
                    if(resp.data.code=='0000'){                       
                        this.productList=resp.data.result;
                        this.totalNum=this.productList.length;
                        this.getPageList(this.pageNum,this.pageSize,this.totalNum,this.productList);
                    }               
                }).catch((resp) => {
                    //console.log('error', resp); 
                })
        },
        //选择承销商
        changeAgent(value){
            this.editorForm.agentCode=value;
            let name=common.getVbyK(this.agentList,value,"agentCode","agentName");
            this.editorForm.agentName=name;
            if(this.operationType=='update'){
                value="";
            }           
            this.$nextTick(() => {                
                this.getProdList(value);
            });  
        },
        //选择延保产品
        changeProd(value){
            this.editorForm.prodCode=value;
            if(this.typeTag==0){
                this.getProdCodeList(value);    
            }            
            let sellType=common.getVbyK(this.prodList,value,"prodCode","sellType");
            let name=common.getVbyK(this.prodList,this.editorForm.prodCode,"prodCode","prodName");
            this.editorForm.prodName=name;
            if(sellType=='1'){
                this.sellTypeTag=true;
            }else{
                this.sellTypeTag=false;
            }         

        },

        resetForm(formName) {
            this.underwriterProductEditorDialog=false;
            this.$refs[formName].resetFields(); 
        },
        submitForm(formName) {
            let usercode=common.getCurrUser().userCode;
            let url="";
            let param=Object.assign({},this.editorForm);
                param.createUser=usercode;
                param.modifyUser=usercode;              
            if(param.state){
                param.state='Y'
            }else{
                param.state='N'
            }

            if(this.operationType=='add'){
                url="/extwarapi/api/agentProduce/add";
                for(let i=0;i<param.agentProducePricesModifyDtoList.length;i++){
                    this.$set(param.agentProducePricesModifyDtoList[i],'id',''); 
                }               
            }else{
                param.agentProducePricesModifyDtoList=[];
                url="/extwarapi/api/agentProduce/update";
            }

            let validFields=["agentCode","prodCode","agentCommission","ysCommission","state"];
            if(this.sellTypeTag){
                validFields.push("tertiaryLevelCommission");
            }            
            let me = this;
            let allValid = true;
            this.$refs[formName].validateField(validFields,(valid) => {
                if(valid.length>0){
                    allValid = false;
                }                
            });
            if (allValid) {
                //判断提成是否等于1
                let math =arithmetic.add5(param.agentCommission,param.ysCommission,param.fistLevelCommission,param.secondLevelCommission,param.tertiaryLevelCommission);
                if(math==100){
                    this.axios.post(url, param).then((resp) => {
                        if(resp.data.code=='0000'){
                            this.$alert("操作成功!", '提示信息', {
                                confirmButtonText: '确定',
                                callback: action => {
                                    this.underwriterProductEditorDialog=false;
                                    this.$refs["myTable"].query(1); 
                                }
                             });
                        }else{
                            this.$alert(resp.data.msg, '提示信息', {
                                confirmButtonText: '确定',
                                callback: action => {
                                
                                }
                             });
                            return;
                        }  
                                
                    }).catch((resp) => {
                        //console.log('error', resp); 
                    })
                }else{
                    this.$alert('一级销售员提成+二级销售员提成+三级销售员提成+承销商提成+友穗提成!=1,请重新填写!', '提示信息', {
                            confirmButtonText: '确定',
                            callback: action => {
                            
                            }
                    });
                    return;
                }
            } else {
                //console.log('error submit!!',allValid);
                return false;
            }
        },
        getDetail(row){
            let url='/extwarapi/api/agentProduce/getDetailById';
            this.axios.post(url, {id:row.id}).then((resp) => {  
                    if(resp.data.code=='0000'){
                        this.editorForm=resp.data.result; 
                        if(resp.data.result.state=='Y'){
                           this.editorForm.state=true; 
                        }else if(resp.data.result.state=='N'){
                           this.editorForm.state=false; 
                        }
                        this.productList=resp.data.result.agentProducePricesDtoList;
                        this.totalNum=this.productList.length;
                        this.getPageList(this.pageNum,this.pageSize,this.totalNum,this.productList);
                    }
                              
                    }).catch((resp) => {
                        //console.log('error', resp); 
                    })
        }
    },
    mounted(){
        this.getAgentList();
       
    }
 
}
</script>
<style lang="scss" >
.priceArea-input {
    width: 150px;
}
.prodCode-select .el-select .el-input__inner{
    width: 215px;
}
.prodCode-input .el-input__inner{
    width: 100px;
}
.input-with-select .el-input-group__prepend {
    background-color: #fff;
}
.commission-input{
    width: 217px;
}
.tertiaryLevelCommission-input {
    width: 231px;
}
.form-name-input .el-input__inner{
    width: 300px;
}
</style>